import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Input from 'components/form/Input';
import Button from 'components/form/Button';

import StartLogo from 'assets/images/start_logo.png';
import useUserStore from '@/store/user';
import { readLogin } from '@/api/balancer/read';
import type { ReadPointUserLoginType, ResReadPointLoginType } from '@/types';
import { SUCCESS } from '@/lib/name-space';
import Toast from '@/lib/toast';
import packageJson from '../../package.json';

export default function Start() {
  // hooks
  const navigate = useNavigate();
  const { telegramId, isLogin, setLogin, setUser, setIds, setPoint } = useUserStore();
  // state
  const [id, setId] = useState('');

  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState('');

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (toastMsg) {
      setShowToast(true);
      timer = setTimeout(() => {
        setShowToast(false);
        setToastMsg('');
      }, 3000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [toastMsg]);

  useEffect(() => {
    if (telegramId && isLogin) {
      navigate('/play');
    }
    return () => {};
  }, [telegramId, isLogin]);

  const handleSubmit = async () => {
    const readPointUserLoginType: ReadPointUserLoginType = {
      id,
      code: import.meta.env.VITE_CODE,
    };
    const re = await readLogin(readPointUserLoginType);
    if (re.status !== SUCCESS) {
      // modal  Login failed
      setToastMsg('Can’t find that Telegram ID. Please double-check or sign up first.');
      return;
    }
    const data: ResReadPointLoginType = re.data;
    setLogin(true);
    setUser(id, data.address, data.referralCode);
    setIds(data.userId, data.settingId, data.pointId);
    setPoint(Number(data.total));
    navigate('/play');
  };
  return (
    <div className="mx-auto flex h-full max-w-[1024px] flex-col items-center bg-[url(assets/images/background.png)] bg-contain bg-center px-[16px] pb-[35px] pt-[68px]">
      <img className="aspect-[1.6] max-h-[200px]" src={StartLogo} alt="start page logo" />
      <div className="mt-auto h-[62px] w-full">
        <div className="relative h-[38px]">
          <Input
            id={'telegramId'}
            className="h-[38px] pr-[60px]"
            placeholder="Please enter your Telegram ID"
            value={id}
            onChange={(e) => setId(e.target.value)}
          />
          <div className="absolute right-[3px] top-[4px] h-[33px]">
            <Button
              text={'Login'}
              onClick={() => {
                handleSubmit();
              }}
            />
          </div>
        </div>

        <div className="mt-[12px] text-center">
          <button onClick={() => navigate('/signup')} className="text-[14px] text-[#4D4840]">
            Sign up
          </button>
        </div>
      </div>
      <div className="mt-[12px] flex w-full justify-end">
        <div className="text-sm text-gray-500">{packageJson.version}</div>
      </div>
      {showToast && (
        <Toast
          message={toastMsg}
          duration={3} // 초 단위
          onClose={() => setShowToast(false)}
        />
      )}
    </div>
  );
}
